"use client";
import React, { useState } from "react";

import { CommunicationItem } from "@/components/widgets/Communication";
import { pandaCallBackConfig } from "@/config/communication.config";
import { EnumModalName } from "@/enums/modal-state";
import CallbackIcon from "@/icons/panda/callback.svg";
import { useModalStore } from "@/store/modal.store";
import { fallBackHandler } from "@/utils/fallback-open-messenger";
import { Popover, PopoverContent, PopoverTrigger } from "@nextui-org/react";
import { useTranslations } from "next-intl";
import Image from "next/image";

const actions: CommunicationItem[] = [
  ...pandaCallBackConfig,
  {
    id: "callback_open",
    icon: CallbackIcon,
    value: "callback",
    label: "Callback request",
    link: "",
  },
];

const PandaButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { openModal } = useModalStore();
  const t = useTranslations("PandaButton");

  const handleAction = (item: CommunicationItem) => {
    if (item.value === "callback") {
      openModal(EnumModalName.callBack);
    } else if (item.link) {
      fallBackHandler(item.link);
    }
    setIsOpen(false);
  };

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={(value) => setIsOpen(value)}
      backdrop="opaque"
      shouldBlockScroll={true}
      placement="top-end"
      classNames={{
        content: "bg-transparent shadow-none pr-0",
        trigger: "aria-expanded:opacity-1 z-50",
      }}
    >
      <PopoverTrigger>
        <button>
          <Image
            width={58}
            height={58}
            src={
              isOpen
                ? "/assets/icons/panda/bearActiveButton.svg"
                : "/assets/icons/panda/bearButton.svg"
            }
            alt="Callback button"
          />
        </button>
      </PopoverTrigger>
      <PopoverContent>
        <ul className="flex flex-col gap-4 items-end">
          {actions.map((item) => (
            <li
              key={item.id}
              className="flex items-center justify-between w-full"
            >
              <button
                id={item.id + "_panda"}
                aria-label={item.value}
                type="button"
                onClick={() => handleAction(item)}
                className="cursor-pointer flex items-center justify-between w-full"
              >
                <span className="bg-white flex-1 h-[38px] flex justify-start rounded-l-small items-center w-full min-w-[148px] pl-[16px] pr-[46px] -mr-[26px] pointer-events-none">
                  <span className="text-[#323232] font-geometria font-normal not-italic text-[18px] leading-[100%] tracking-normal align-middle pointer-events-none">
                    {t(item.label)}
                  </span>
                </span>

                <item.icon
                  className="pointer-events-none"
                  width={52}
                  height={52}
                  alt={item.label}
                />
              </button>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
};

export default PandaButton;
